import { ApiService } from '@ibe/services';
import useAppService from './useAppService';

function useApi(): ApiService {
  const app = useAppService();
  return app.api;
}

export default useApi;
